export default __webpack_public_path__ + "static/media/manager.bbad303c.png";